<div class="flex flex-col">

  <h1 class="text-lg">Send Message</h1>

  <form class="flex flex-col"
    [formGroup]="form"
    (ngSubmit)="submit()">
  
    <app-select-phone-number (selected)="onFromSelected($event)" type="twilio">

      <mat-form-field class="flex grow">
    
        <mat-label>From:</mat-label>
  
        <input type="tel"
          formControlName="from"
          matInput>

        <mat-hint>{{fromHint()}}</mat-hint>
  
        <mat-error>This field is required.</mat-error>
  
      </mat-form-field>
  
    </app-select-phone-number>

    <app-select-phone-number [from]="from()" (selected)="onToSelected($event)" type="contacts">
      
      <mat-form-field>

        <mat-label>To:</mat-label>

        <input type="tel"
          formControlName="to"
          matInput>

        <mat-hint>{{toHint()}}</mat-hint>

        <mat-error>This field is required.</mat-error>

      </mat-form-field>

    </app-select-phone-number>

    <mat-form-field>

      <mat-label>Message</mat-label>

      <textarea 
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="15"
        formControlName="body"
        matInput
        ></textarea>

      <mat-error>A message is required.</mat-error>

    </mat-form-field>

    <div class="flex flex-col">

      <div class="flex flex-row items-center justify-between">

        <input #file type="file" (change)="onFileSelected($event)">

        <button type="button" (click)="file.click()" mat-button="filled">Add Media</button>

        <div class="flex flex-row items-center justify-center">

          <span>Total: {{attachmentSizeTotal()}}</span>

          @if (tooBig()) {

            <span>Attachments are too large.</span>

          }

        </div>

      </div>

      <div class="flex flex-col gap-2">

        @for (att of attachments(); track $index) {

          <div class="flex flex-row items-center justify-between">

            <span>{{att.file.name}}</span>

            <span>{{att.status}}</span>

            <button type="button" (click)="deleteAttachment(att)" mat-icon-button><mat-icon>delete</mat-icon></button>

          </div>

        }

      </div>

    </div>

    <div class="flex flex-row justify-between">

      <span>&nbsp;</span>

      <mat-spinner *ngIf="processing()" diameter="30"></mat-spinner>

      <button type="submit" color="primary"
        [disabled]="form.invalid || processing()"
        mat-raised-button>Send Message</button>

    </div>

  </form>

</div>
